import { render, staticRenderFns } from "./in-out-stock-chart.vue?vue&type=template&id=b1f35bd0&scoped=true&"
import script from "./in-out-stock-chart.vue?vue&type=script&lang=js&"
export * from "./in-out-stock-chart.vue?vue&type=script&lang=js&"
import style0 from "./in-out-stock-chart.vue?vue&type=style&index=0&id=b1f35bd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f35bd0",
  null
  
)

export default component.exports